import { mapPresetToState } from '../schemas';
import { creativesTrackerReducer } from './creativesTrackerReducer';
import {
  APPLY,
  SET_FILTERS,
  APPLY_PRESET,
  SET_METRICS,
  SET_ADVANCED_FILTERS,
} from './constants';

export function creativesTrackerTemporaryStateReducer(state, action) {
  switch (action.type) {
    case APPLY: {
      const actionBeforeApply = action.payload;
      let newState = state.temporary ? state.temporary : state;

      newState = creativesTrackerReducer(state, {
        type: APPLY,
        payload: actionBeforeApply
          ? creativesTrackerReducer(newState, actionBeforeApply)
          : newState,
      });

      return {
        ...newState,
        ready: true,
        temporary: null,
      };
    }

    case APPLY_PRESET:
      if (action.payload) {
        const { id, data } = action.payload;
        const { applyPresetData } = action.meta;

        // if applyPresetData is 'false', it is new preset and it's data equal to current state
        return {
          ...(applyPresetData ? mapPresetToState(data) : state),
          ready: true,
          presetId: id,
          temporary: null,
        };
      }
      // Active preset was removed
      return {
        ...state,
        // clean activePresetId
        presetId: undefined,
        temporary: null,
      };

    case SET_ADVANCED_FILTERS:
    case SET_METRICS:
    case SET_FILTERS: {
      const temporaryState = ensureTemporaryState(state);
      return {
        ...state,
        temporary: creativesTrackerReducer(temporaryState, action),
      };
    }

    default:
      return creativesTrackerReducer(
        {
          ...state,
          ...(state.temporary
            ? { temporary: creativesTrackerReducer(state.temporary, action) }
            : null),
        },
        action
      );
  }
}

export function ensureTemporaryState({ temporary, ...state }) {
  return temporary ? temporary : state;
}
